import React from "react";
import axios from "axios";

import { BACKEND_CONFIG } from "../../config/consts";
import ClientBackHeader from "../../components/ClientBackHeader";
import { QuoteChangeRequest } from "../quote-change-request/QuoteChangeRequest";

import RequestQuoteChangeTable from "./RequestQuoteChangeTable";

class RequestQuoteChangePage extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      requests: [],
      selected: [],
      uploadFiles: [],
      isFirstStep: true,
    };
  }

  unselectRequest(id) {
    this.setState({
      selected: [],
    });
  }

  selectRequest(id) {
    this.setState({
      selected: [id],
    });
  }

  goBack() {
    this.props.history.goBack();
  }

  nextStep() {
    this.setState({ isFirstStep: false });
  }

  prevStep() {
    this.getRequests();
    this.setState({ isFirstStep: true, selected: [] });
  }

  getRequests() {
    axios
      .get(
        `${BACKEND_CONFIG.apiUrl}agency/clients/` +
          this.props.match.params.id +
          "/quotes"
      )
      .then((result) => {
        this.setState({
          requests: result.data,
        });
      })
      .catch((error) => {});
  }

  componentDidMount() {
    this.getRequests();
  }

  handleUploadFile(file) {
    this.setState({
      uploadFiles: [...this.state.uploadFiles, file],
    });
  }

  handleDeleteUploadedFile(index) {
    axios.delete(
      `${BACKEND_CONFIG.apiUrl}/documents/${this.props.match.params.id}/files/${this.state.uploadFiles[index].Id}`
    );
    var newArr = [...this.state.uploadFiles];
    newArr.splice(index, 1);
    this.setState({
      uploadFiles: [...newArr],
    });
  }

  render() {
    var requestHeader = "Request Quote Change (Limit One)";
    var stepPage = this.state.isFirstStep ? (
      <RequestQuoteChangeTable
        nextStep={() => this.nextStep()}
        goBack={() => this.goBack()}
        selected={this.state.selected}
        requests={this.state.requests}
        unselectRequest={(r) => this.unselectRequest(r)}
        selectRequest={(r) => this.selectRequest(r)}
      />
    ) : (
      <QuoteChangeRequest
        quoteIds={this.extractSelectedQuoteIds()}
        prevStep={() => this.prevStep()}
        history={this.props.history}
        onServerValidationErrors={(e) => this.props.onServerValidationErrors(e)}
      />
    );

    return (
      <div>
        <ClientBackHeader
          clientId={this.props.match.params.id}
          goBack={() => this.goBack()}
        />
        <h1 className="mb-4">{requestHeader}</h1>
        {stepPage}
      </div>
    );
  }

  extractSelectedQuoteIds() {
    return this.state.selected;
  }
}

export default RequestQuoteChangePage;
